import styled, { css } from "styled-components";
import { categoryList } from "../../types/types";

const Wrapper = styled.div<{
  index: number;
  $onClose: boolean;
}>`
  display: ${(props) => (props.$onClose ? "flex" : "none")};
  flex-direction: column;
  z-index: 99999;
  justify-content: center;
  align-items: center;
  width: 26vw;
  backdrop-filter: blur(4px);
  background-color: #ffffffbe;
  border-radius: 0.6vw;
  position: absolute;
  left: ${(props) => (props.index % 2 ? "26vw" : "-27vw")};
  top: ${(props) => (props.index >= 9 ? "" : "0")};
  bottom: ${(props) => (props.index >= 9 ? "11vw" : "")};
  outline: 0.2vw solid #ff7f3b;
`;

const SelectionBox = styled.div<{
  index: number;
  $selectedItem: number;
}>`
  width: 100%;
  height: 6vw;
  font-size: 2.4vw;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.$selectedItem - 1 === props.index ? "#ff7f3b" : "none"};
  color: ${(props) =>
    props.$selectedItem - 1 === props.index ? "white" : "black"};
`;

export default function ItemDropdown(props: any) {
  const { index, onClose, selectedItem, setSelectedItem } = props;
  const data = categoryList[index - 1];
  return (
    <Wrapper index={index} $onClose={onClose}>
      {data.itemList.map((item: any, index: number) => {
        return (
          <SelectionBox
            key={index}
            index={index}
            $selectedItem={selectedItem}
            onClick={() => {
              setSelectedItem(item.type);
            }}
          >
            {item.itemName}
          </SelectionBox>
        );
      })}
    </Wrapper>
  );
}
